<template>
    <div class="pub-page">
        <!-- 顶部卡片 -->
        <div class="top-card">
            <div class="project-info">
                <span class="info-item">
                    <span class="info-label">招标项目名称：</span>
                    <span class="info-value">{{ projectName }}</span>
                </span>
                <span class="info-sep"></span>
                <span class="info-item">
                    <span class="info-label">招标项目编号：</span>
                    <span class="info-value">{{ projectCode }}</span>
                </span>
            </div>
            <div class="top-actions">
                <el-button class="btn-outline" @click="handleChangeNotice">
                    <i class="el-icon-document"></i> 变更公告
                </el-button>
                <el-button class="btn-primary" @click="handleAdd">
                    <i class="el-icon-plus"></i> 新增招标公告
                </el-button>
                <el-button class="btn-back" @click="handleBack">
                    <i class="el-icon-arrow-left"></i> 返回
                </el-button>
            </div>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
            <div class="table-header">
                <span class="header-title">招标公告列表</span>
            </div>
            <el-table :data="tableData" border class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="noticeName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="publishDate" label="公告发布日期" width="120" align="center" />
                <el-table-column prop="deadline" label="截止时间" width="120" align="center" />
                <el-table-column prop="releaseDate" label="发布日期" width="120" align="center" />
                <el-table-column prop="status" label="发布状态" width="100" align="center">
                    <template slot-scope="scope">
                        <span class="status-tag" :class="`status-tag--${scope.row.statusType}`">
                            {{ scope.row.status }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" class="detail-btn" @click="handleDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handlePageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BidAnnouncementPublish',

    data() {
        return {
            projectName: '',
            projectCode: '',
            tableData: [],
            total: 1,
            pageSize: 10,
            currentPage: 1
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || '中山大厦项目'
        this.projectCode = this.$route.query.projectCode || 'E1101050893002128'
        this.loadData()
    },

    methods: {
        loadData() {
            this.tableData = [
                {
                    no: 1,
                    noticeName: '中山大厦建设项目招标公告',
                    sectionName: '第一标段',
                    publishDate: '2025-10-01',
                    deadline: '2025-10-15',
                    releaseDate: '2025-10-01',
                    status: '已发布',
                    statusType: 'success'
                }
            ]
            this.total = 1
        },

        handleBack() {
            this.$router.push({
                path: '/agentHome/projectWorkflow',
                query: { projectName: this.projectName, projectCode: this.projectCode }
            })
        },

        handleAdd() {
            this.$message.info('新增招标公告')
        },

        handleChangeNotice() {
            this.$message.info('变更公告')
        },

        handleDetail(row) {
            this.$message.info(`查看公告详情：${row.noticeName}`)
        },

        handlePageChange(page) {
            this.currentPage = page
        }
    }
}
</script>

<style lang="less" scoped>
.pub-page {
    background: #F2F4F7;
    min-height: 100vh;
    padding: 20px 16px;
}

// ===== 顶部卡片 =====
.top-card {
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 4px;
    padding: 14px 20px;
    flex-wrap: wrap;
    gap: 12px;
}

.project-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.info-item {
    font-size: 14px;
}

.info-label {
    color: #606266;
}

.info-value {
    color: #303133;
    font-weight: 500;
}

.info-sep {
    width: 1px;
    height: 16px;
    background: #DCDFE6;
    margin: 0 16px;
}

.top-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-primary {
    background: #1890FF;
    border-color: #1890FF;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;

    i { margin-right: 4px; }

    &:hover {
        background: #40A9FF;
        border-color: #40A9FF;
    }
}

.btn-outline {
    background: #fff;
    border-color: #1890FF;
    color: #1890FF;
    border-radius: 4px;
    font-size: 14px;

    i { margin-right: 4px; }

    &:hover {
        background: #E6F7FF;
        border-color: #40A9FF;
        color: #40A9FF;
    }
}

.btn-back {
    background: #fff;
    border-color: #DCDFE6;
    color: #606266;
    border-radius: 4px;
    font-size: 14px;

    i { margin-right: 4px; }

    &:hover {
        color: #409EFF;
        border-color: #409EFF;
    }
}

// ===== 表格卡片 =====
.table-card {
    margin: 0 auto;
    background: #fff;
    border-radius: 4px;
}

.table-header {
    padding: 14px 20px;
    border-bottom: 1px solid #EBEEF5;
}

.header-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.data-table {
    border: none;
    border-radius: 0;

    /deep/ .el-table__header-wrapper th {
        background: #FAFAFA;
        color: #606266;
        font-weight: 500;
        font-size: 13px;
    }

    /deep/ .el-table__cell {
        padding: 13px 0;
        font-size: 13px;
        color: #606266;
    }
}

.status-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 12px;
    border: 1px solid;

    &--success {
        color: #67C23A;
        border-color: #c2e7b0;
        background: #f0f9eb;
    }

    &--warning {
        color: #E6A23C;
        border-color: #faecd8;
        background: #fdf6ec;
    }

    &--info {
        color: #909399;
        border-color: #d3d4d6;
        background: #f4f4f5;
    }
}

.detail-btn {
    color: #409EFF;
    font-size: 13px;
    padding: 0;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    padding: 14px 16px;
    border-top: 1px solid #EBEEF5;
}
</style>
